import { OpenNewTabTargetType, } from '@voltmoney/types';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { IconTokens, WIDGET, } from '@voltmoney/schema';
import SharedPropsService from '../../../SharedPropsService';
import { api } from '../../../configs/api';
import { APP_CONFIG, getAppHeader, } from '../../../configs/config';
import { POPUP_TARGET_NAME } from '../../../configs/constants';
import { Platform } from 'react-native';
import { getParameters } from '../../../configs/uri-config-utils';
import { nextStepCredStepper } from "../../../configs/utils";
let stepResponseObject = null;
let hasNavigate = false;
export const authenticateRepayment = async (action, _datastore, { instrumentTrack, showPopup }) => {
    if (action.payload.value) {
        showPopup({
            type: 'DEFAULT',
            iconName: IconTokens.Redirecting,
            title: 'Please click continue for AutoPay',
            subTitle: 'Return to Volt after successful completion',
            ctaLabel: 'Continue',
            ctaAction: {
                type: ACTION.OPEN_TAB,
                routeId: ROUTE.LOAN_REPAYMENT,
                payload: {
                    value: action.payload.value,
                },
            },
            isAutoTriggerCta: false
        });
    }
};
export const goBack = async (action, _datastore, { goBack, navigate }) => {
    await navigate(ROUTE.KYC_STEPPER, {});
};
// export const AutoPayPoll: ActionFunction<LimitPayload> = async (
//   action,
//   _datastore,
//   props
// ): Promise<any> => {
//   await props.setDatastore(ROUTE.LOAN_REPAYMENT, "btnItem", <ButtonProps>{
//     loading: true,
//   });
//   const timer = setInterval(async () => {
//     const response = await fetchLinkRepo();
//     if (response.stepResponseObject)
//       stepResponseObject = response.stepResponseObject;
//     if (stepResponseObject) {
//       await props.setDatastore(ROUTE.LOAN_REPAYMENT, "btnItem", <ButtonProps>{
//         loading: false,
//       });
//       clearInterval(timer);
//       await authenticateRepayment(
//         {
//           type: ACTION.REPAYMENT,
//           payload: <LimitPayload>{
//             value: stepResponseObject,
//             widgetId: "input",
//           },
//           routeId: ROUTE.LOAN_REPAYMENT,
//         },
//         {},
//         props
//       );
//     }
//   }, 2000);
// };
export const openLinkInNewTab = async (action, _datastore, { appendWidgets, removeWidgets, showPopup, openNewTab, hidePopup, ...props }) => {
    if (action.payload.value) {
        if (Platform.OS === 'web' ||
            Platform.OS === 'android' ||
            Platform.OS === 'ios') {
            let isFromiOSSdk;
            if (Platform.OS === 'web') {
                const params = getParameters(window.location.href);
                isFromiOSSdk = params?.isFromiOSSdk;
            }
            console.warn("VALUE OF LINK IS", action.payload.value);
            if (isFromiOSSdk) {
                // @ts-ignore
                window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage(action.payload.value);
            }
            else {
                openNewTab(action.payload.value, OpenNewTabTargetType.popup, {
                    target: POPUP_TARGET_NAME.AUTOPAY,
                    width: APP_CONFIG.POP_UP_SIZE.WIDTH,
                    height: APP_CONFIG.POP_UP_SIZE.HEIGHT,
                });
            }
            hidePopup();
            showPopup({
                isAutoTriggerCta: true,
                type: 'DEFAULT',
                iconName: IconTokens.Redirecting,
                title: 'Waiting for response',
                subTitle: 'Please wait while we process your request',
                ctaAction: {
                    type: ACTION.POLL_MANDATE_STATUS,
                    routeId: ROUTE.LOAN_REPAYMENT,
                    payload: {},
                },
                primary: false,
            });
            return;
        }
        await appendWidgets(ROUTE.LOAN_REPAYMENT, {
            repaymentWebView: {
                uri: action.payload.value,
            },
        }, [{ id: 'repaymentWebView', type: WIDGET.WEB_VIEW }], 'headerSpace');
        await removeWidgets(ROUTE.LOAN_REPAYMENT, [
            { id: 'contentItem', type: WIDGET.TEXT },
            { id: 'contentSpace', type: WIDGET.SPACE },
            { id: 'iconStack', type: WIDGET.STACK },
            { id: 'iconSpace', type: WIDGET.SPACE },
            { id: 'btnData', type: WIDGET.STACK },
        ]);
        await PollMandateStatus(action, {}, {
            appendWidgets,
            removeWidgets,
            showPopup,
            openNewTab,
            hidePopup,
            ...props,
        });
    }
};
export const PollMandateStatus = async (action, _datastore, { showPopup, hidePopup, instrumentTrack, network, navigateWithClear, goBack }) => {
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const getApiLoad = async () => {
        await network
            .get(`${api.mandateStatus}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(response => {
            return response.data;
        })
            .then(async (response) => {
            //add timer
            if (response.stepResponseObject.toLowerCase() === 'finished' && response?.updatedApplicationObj?.currentStepId !== 'MANDATE_SETUP') {
                clearInterval(timer);
                if (Platform.OS === 'web')
                    // @ts-ignore
                    window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closePop");
                const user = await SharedPropsService.getUser();
                user.linkedApplications[0] = response.updatedApplicationObj;
                await SharedPropsService.setUser(user);
                const url = Platform.OS === 'web' ? window.location.href : '';
                const params = Platform.OS === 'web' ? getParameters(url) : {};
                hidePopup();
                const routeObj = await nextStepCredStepper(user.linkedApplications[0].currentStepId);
                if (Platform.OS === "web") {
                    //@ts-ignore
                    window?.ReactNativeWebView?.postMessage("closePop");
                }
                setTimeout(() => {
                    !hasNavigate &&
                        navigateWithClear(ROUTE.DASHBOARD);
                }, 3000);
                showPopup({
                    isAutoTriggerCta: false,
                    type: 'SUCCESS',
                    title: 'AutoPay setup successful!',
                    subTitle: 'Interest charges will be deducted automatically every month.',
                    ctaLabel: 'Continue',
                    ctaAction: {
                        type: ACTION.GO_T0_DASHBOARD,
                        routeId: ROUTE.LOAN_REPAYMENT,
                        payload: {},
                    },
                    shouldAutoNavigate: true,
                });
            }
            else if (response.stepResponseObject.toLowerCase() === 'failed') {
                console.log('Poller fialed');
                if (Platform.OS === 'web')
                    // @ts-ignore
                    window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closePop");
                clearInterval(timer);
                hidePopup();
                showPopup({
                    isAutoTriggerCta: false,
                    type: 'FAILED',
                    title: 'AutoPay setup failed!',
                    subTitle: 'Bank account must be linked for AutoPay. Please try again.',
                    ctaLabel: 'Continue to try again',
                    ctaAction: {
                        type: ACTION.GO_LOAN_REPAYMENT,
                        routeId: ROUTE.LOAN_REPAYMENT,
                        payload: {},
                    },
                    primary: true,
                });
            }
        });
    };
    const timer = setInterval(() => {
        getApiLoad();
    }, APP_CONFIG.POLLING_INTERVAL);
};
export const NavLoanAgreement = async (action, _datastore, { hidePopup }) => {
    await hidePopup();
};
export const NavLoanRepayment = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.LOAN_REPAYMENT);
};
export const GoToDashboard = async (action, _datastore, { navigate, goBack, navigateWithClear, navigateToBase }) => {
    hasNavigate = true;
    const user = await SharedPropsService.getUser();
    const routeObj = await nextStepCredStepper(user.linkedApplications[0].currentStepId);
    if (Platform.OS === "web") {
        //@ts-ignore
        window?.ReactNativeWebView?.postMessage("LOAN_CREATED");
    }
    await navigateToBase(routeObj.routeId, routeObj.params);
};
